import React from 'react';
import {
  Box,
  VStack,
  Text,
  Icon,
  Divider,
  Alert,
  AlertIcon,
  Flex,
} from '@chakra-ui/react';
import { FaBell } from 'react-icons/fa';

const NotificationPanel = () => {
  const notifications = [
    { id: 1, type: 'info', message: 'KYC submitted by User123 pending review.' },
    { id: 2, type: 'success', message: 'KYC approved for User456.' },
    { id: 3, type: 'error', message: 'KYC verification failed for User789.' },
  ];

  return (
    <Box w="318px" bg="brand.700" color="white" shadow="lg" overflowY="auto" maxH="calc(100vh - 100px)"> {/* Adjust maxH */}
      <VStack p={6} spacing={4} align="stretch">
        <Flex align="center">
          <Icon as={FaBell} boxSize={6} />
          <Text ml={4} fontWeight="bold" fontSize="lg">
            Notifications
          </Text>
        </Flex>

        <Divider borderColor="gray.500" />

        {notifications.map((notification) => (
          <Alert
            key={notification.id}
            status={notification.type}
            variant="subtle"
            flexDirection="row"
            alignItems="center"
            justifyContent="flex-start"
            textAlign="left"
          >
            <AlertIcon />
            <Text>{notification.message}</Text>
          </Alert>
        ))}
      </VStack>
    </Box>
  );
};

export default NotificationPanel;
